import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Layout = ({ title, children, testId }) => {
  useEffect(() => {
    document.title = `${title} — NBPerf`;
    return () => {
      document.title = "NBPerf — Reprogrammation moteur E85 & diesel";
    };
  }, [title]);

  return (
    <main className="pt-16 min-h-screen" data-testid={testId}>
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-white/50 hover:text-[#6EB000] text-sm uppercase tracking-widest transition-colors"
          data-testid={`${testId}-back`}
        >
          <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
        </Link>
        <h1 className="font-display text-4xl sm:text-6xl text-white mt-10 mb-10">{title}</h1>
        <div className="space-y-8 text-white/70 text-sm sm:text-base leading-relaxed">{children}</div>
      </div>
    </main>
  );
};

const Block = ({ title, children }) => (
  <section>
    <h2 className="font-display text-xl sm:text-2xl text-[#6EB000] mb-3">{title}</h2>
    {children}
  </section>
);

export function MentionsLegales() {
  return (
    <Layout title="Mentions légales" testId="mentions-legales-page">
      <Block title="Éditeur du site">
        <p>
          NBPerf — Nicolas Bourillon
          <br />
          Entrepreneur individuel — SIRET : 504 715 137 00072
          <br />
          Tél. : 07 81 90 12 48
          <br />
          Email : nbperformance@outlook.fr
          <br />
          Site : www.nbperformance.fr
        </p>
      </Block>
      <Block title="Directeur de la publication">
        <p>Nicolas Bourillon</p>
      </Block>
      <Block title="Hébergement">
        <p>
          Ce site est hébergé par Emergent — emergent.sh.
          <br />
          Les coordonnées complètes de l'hébergeur sont disponibles sur demande.
        </p>
      </Block>
      <Block title="Propriété intellectuelle">
        <p>
          L'ensemble des contenus du site (textes, visuels, logo NBPerf) est la propriété exclusive de
          NBPerf, sauf mention contraire. Toute reproduction sans autorisation écrite est interdite.
        </p>
      </Block>
      <Block title="Responsabilité">
        <p>
          Les prix et estimations affichés sur ce site sont donnés à titre indicatif. Toute intervention
          fait l'objet d'une étude préalable et d'un devis personnalisé. Certaines prestations sont
          réservées à un usage compétition ou hors route ouverte, comme indiqué sur les pages concernées.
        </p>
      </Block>
    </Layout>
  );
}

export function PolitiqueConfidentialite() {
  return (
    <Layout title="Politique de confidentialité" testId="privacy-page">
      <Block title="Données collectées">
        <p>
          Via le formulaire de contact, nous collectons uniquement : votre nom, numéro de téléphone,
          adresse email, véhicule, prestation souhaitée et votre message. Aucune autre donnée n'est
          collectée sans votre accord.
        </p>
      </Block>
      <Block title="Finalité du traitement">
        <p>
          Ces données servent exclusivement à répondre à votre demande d'étude ou de devis et à assurer
          le suivi commercial de votre dossier. Elles ne sont ni vendues, ni transmises à des tiers.
        </p>
      </Block>
      <Block title="Durée de conservation">
        <p>
          Vos données sont conservées pendant la durée nécessaire au traitement de votre demande, puis
          archivées au maximum 3 ans à des fins de suivi.
        </p>
      </Block>
      <Block title="Vos droits (RGPD)">
        <p>
          Conformément au Règlement Général sur la Protection des Données, vous disposez d'un droit
          d'accès, de rectification, d'opposition et de suppression de vos données. Pour exercer ces
          droits : nbperformance@outlook.fr ou 07 81 90 12 48.
        </p>
      </Block>
      <Block title="Cookies">
        <p>Ce site n'utilise pas de cookie de suivi ou publicitaire.</p>
      </Block>
    </Layout>
  );
}
